export default function SectionDivider() {
  return (
    <div className="relative z-10 px-6 md:px-16 lg:px-24">
      <div
        className="h-px"
        style={{
          background:
            "linear-gradient(to right, transparent, rgba(96,165,250,0.15), rgba(167,139,250,0.12), transparent)",
        }}
      />
    </div>
  );
}
